module.exports = __webpack_public_path__ + "static/media/calendar-tick.e985b27f.svg";